import { PhoneApps } from './phone';

export enum PhoneMessageDirection {
	Incoming = 'incoming',
	Outgoing = 'outgoing',
}

export interface IPhoneMessage {
	id: number;
	dialogId: number;
	text: string;
	createdAt: number;
	authorPhoneNumber: string;
	direction: PhoneMessageDirection;
}

export interface IPhoneDialogPeer {
	phoneNumber: string;
	name: string;
}

export interface IPhoneDialog {
	id: number;
	peer: IPhoneDialogPeer;
	lastMessage: IPhoneMessage | null;
	unreadCount: number;
	updatedAt: number;
}

export interface IPhoneContactPresence {
	phoneNumber: string;
	isOnline: boolean;
	lastSeenAt?: number;
}

export interface IPhoneMessageNotificationPayload {
	dialogId: number;
	message: IPhoneMessage;
	app?: PhoneApps;
}
